module.exports = __webpack_public_path__ + "static/media/fifteenth_cleo_rogers_memorial_library3.ba38c4f6.jpg";